import React from "react";
import ResetPassword from "../components/ResetPassword";

const ResetPasswordPage = () => {
  return (
    <>

      {/* SignInLayer */}
      <ResetPassword />

    </>
  );
};

export default ResetPasswordPage;   
